import { render, staticRenderFns } from "./VideoLoginModal.vue?vue&type=template&id=8e124500&"
import script from "./VideoLoginModal.vue?vue&type=script&lang=js&"
export * from "./VideoLoginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports